"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Basic = _interopRequireDefault(require("./templates/Basic"));
var _AvatarCustomized = _interopRequireDefault(require("./templates/AvatarCustomized"));
var templates = {
  AvatarCustomized: _AvatarCustomized["default"],
  Basic: _Basic["default"]
};
var List = function List(_ref) {
  var heading = _ref.heading,
    items = _ref.items,
    _ref$template = _ref.template,
    template = _ref$template === void 0 ? 'Basic' : _ref$template,
    noNotificationText = _ref.noNotificationText,
    noMaxHeight = _ref.noMaxHeight;
  var TemplateSelected = templates[template];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-list d8-u-relative flex flex-column justify-between height-100%".concat(noMaxHeight ? ' max-height-none' : '')
  }, heading && /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--top margin-bottom-md"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-xs d8-u-color-contrast-high d8-u-text-uppercase d8-u-ls-sm"
  }, heading)), items && /*#__PURE__*/_react["default"].createElement(TemplateSelected, {
    items: items,
    noNotificationText: noNotificationText
  }));
};
List.propTypes = {
  heading: _propTypes["default"].string,
  items: _propTypes["default"].array,
  template: _propTypes["default"].string,
  noNotificationText: _propTypes["default"].bool,
  noMaxHeight: _propTypes["default"].bool
};
List.deafultProps = {
  items: [],
  template: 'Basic'
};
var _default = exports["default"] = List;